import IssueIcon from '@assets/images/issue-icon.svg?react'
import Typography from '@/ui/components/typography'
import { DrawerHeaderConfig } from '@ui/drawer/common/DrawerNavigationHeader'
import IssueDrawerHeaderBadges from './IssueDrawerHeaderBadges'
import { getIssueCategoryLabel } from './issueCategoryConfig'
import { LabelRow } from './issueDrawerHeaderConfig.styles'

export const issueDrawerHeaderConfig: DrawerHeaderConfig<TIssue> = {
    itemsKey: 'issues',
    indexKey: 'index',
    icon: () => <IssueIcon width={50} height={50} />,
    label: (issue) => (
        <LabelRow>
            <Typography variant="m-regular">
                {getIssueCategoryLabel(issue?.issue_category)}
            </Typography>
            {issue && <IssueDrawerHeaderBadges issue={issue} />}
        </LabelRow>
    ),
    title: (issue) => (
        <Typography
            component="span"
            variant="l-regular"
            noWrap={false}
            testId={
                issue?.issue_type
                    ? `${issue.issue_type.toLowerCase()}-drawer-navigation-title`
                    : 'drawer-navigation-title'
            }
        >
            {issue?.name ?? 'Issue details'}
        </Typography>
    ),
}
